module.exports = __webpack_public_path__ + "static/media/stone-main.09298f5d.png";